module.exports = __webpack_public_path__ + "site/img/223.a2bb872d.jpg";